import { apiClient } from "../config";

async function deleteConversation(id: string) {
  const res = await apiClient.delete(`/admin/conversations/${id}/chat`);
  return res.data;
}

export default deleteConversation;
